import { makeRowsByAllAccounts } from '../layout/accounts-list/make-rows-by-all-accounts.js'
import { makeColumnDefs } from '../layout/accounts-list/make-column-defs.js'
import { makeRowsByLayout } from '../layout/statement-layout/make-rows-by-layout.js'
import { makeLayoutColumnDefs } from '../layout/statement-layout/make-layout-column-defs.js'
import { computeConsolidation } from './compute/consolidation-data.js'
import { indexValuesDB } from './index-values-db.js'

export function makeGridData (context) {
  console.log('makeGridData', context)

  computeConsolidation(context)
  indexValuesDB()

  const gridData = {
    rows: [],
    columns: []
  }

  if (context.gridMethod === 'byAllAccounts') {
    gridData.rows = makeRowsByAllAccounts(context)
    gridData.columns = makeColumnDefs(context)
  } else { // byLayout
    console.time('makeGridData')
    gridData.columns = makeLayoutColumnDefs(context)
    gridData.rows = makeRowsByLayout(context, gridData.columns)

    // console.log('columns', columns)
    console.timeEnd('makeGridData')
  }

  return gridData
}
